import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { dialogContainerAnimation } from './dialog-animation';
import { AsyncPipe, NgIf } from '@angular/common';
import { AssetsPathPipe } from '@gelato-api-ui/sdk/src/lib/pipes/assets-path.pipe';

@Component({
  standalone: true,
  selector: 'gd-dialog-container',
  templateUrl: './dialog-container.component.html',
  styleUrls: ['./dialog-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [dialogContainerAnimation],
  imports: [NgIf, AssetsPathPipe, AsyncPipe],
  encapsulation: ViewEncapsulation.None,
})
export class DialogContainerComponent {
  @Input() closable = true;
  @Output() close = new EventEmitter<void>();

  @HostBinding('@dialogContainer') get fadeInDesktop(): string {
    return 'enter';
  }
}
